export const AUDIT_STATUS_OPTIONS = [
  { value: 'a_verifier', label: 'À vérifier', className: 'bg-amber-500 text-white' },
  { value: 'ok', label: 'OK', className: 'bg-emerald-600 text-white' },
  { value: 'dupliquee', label: 'Dupliquée', className: 'bg-orange-500 text-white' },
  { value: 'obsolete', label: 'Obsolète', className: 'bg-slate-500 text-white' },
  { value: 'a_supprimer', label: 'À supprimer', className: 'bg-red-600 text-white' }
];

export const CATEGORY_LABELS = {
  extranet: 'Pages Extranet (Collaborateurs)',
  manager: 'Pages Manager/Directeur',
  admin: 'Pages Administration (Directeur)',
  public: 'Pages Site Public'
};

export const CATEGORY_ORDER = ['extranet', 'manager', 'admin', 'public'];